import { render, staticRenderFns } from "./sharia_doa.vue?vue&type=template&id=d9af7be8"
import script from "./sharia_doa.vue?vue&type=script&lang=js"
export * from "./sharia_doa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports